import { useState } from 'react';
import { navigateToUrlWithSelectedPropertyId } from '../../utils/navigation-helpers';
import { SUBSIDY_FILTER_ALL } from './constants';
import useSelectedProperty from '../../hooks/useSelectedProperty';
import useUserOrganizationId from '../../hooks/useUserOrganizationId';
import useIntl from '../../hooks/useIntl';

export const useManagePaymentBatches = () => {
  const intl = useIntl();
  const selectedProperty = useSelectedProperty();
  const organizationId = useUserOrganizationId();
  const propertyId = selectedProperty?.id;
  const [subsidyFilter, setSubsidyFilter] = useState(SUBSIDY_FILTER_ALL);
  const [periodFilter, setPeriodFilter] = useState('');

  const redirectToCreatePaymentBatch = () => {
    navigateToUrlWithSelectedPropertyId('/payment-batch');
  };

  const redirectToPaymentBatch = (
    paymentBatchHeaderId: string,
    isSubsidyBatch: boolean,
  ) => {
    if (isSubsidyBatch) {
      navigateToUrlWithSelectedPropertyId(
        `/create-subsidy-batch/${paymentBatchHeaderId}`,
      );
      return;
    }
    navigateToUrlWithSelectedPropertyId(
      `/payment-batch/${paymentBatchHeaderId}`,
    );
  };

  return {
    intl,
    organizationId,
    propertyId,
    subsidyFilter,
    setSubsidyFilter,
    periodFilter,
    setPeriodFilter,
    redirectToCreatePaymentBatch,
    redirectToPaymentBatch,
  };
};
